
import { ChangeDetectionStrategy, Component, inject, input, Input, output } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { GTMService } from '@shared/gtm';
import {
  BillingAddressComponent,
  PersonalDetails,
  PersonalDetailsComponent,
  ResidentialAddress,
} from '@shared/ui-service';
import { ResidentialBillingInfo } from '../../models/residential-billing-info.model';

const CSL_IMPORTS = [PersonalDetailsComponent, BillingAddressComponent];

@Component({
  selector: 'csl-billing-form-residential',
  standalone: true,
  imports: [FormsModule, ...CSL_IMPORTS],
  templateUrl: './billing-form-residential.component.html',
  styleUrl: './billing-form-residential.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingFormResidentialComponent {
  private readonly gtmService = inject(GTMService);

  @Input({ required: true }) address!: ResidentialAddress;
  formStep = input.required<'residential' | 'dumpster'>();

  modelChange = output<ResidentialBillingInfo | null>();

  private personalDetails: PersonalDetails | null = null;
  private personalAddress: ResidentialAddress | null = null;

  addressChanged(address: ResidentialAddress | null): void {
    this.personalAddress = address;
    this.stepModelChanged();
  }

  onPersonalDetailsChange(personalDetails: PersonalDetails | null): void {
    this.personalDetails = personalDetails;
    this.stepModelChanged();
  }

  trackControlError(controlName: string, error: string): void {
    this.gtmService.formStep3ErrorEvent(this.formStep(), controlName, error);
  }

  private stepModelChanged(): void {
    const isValid = !!(this.personalAddress && this.personalDetails);
    const model = isValid
      ? ({
          personalAddress: this.personalAddress,
          personalDetails: this.personalDetails,
        } as ResidentialBillingInfo)
      : null;

    this.modelChange.emit(model);
  }
}
